import { Injectable } from '@angular/core';
import { CanActivate, Router } from "@angular/router";
import { JWTService } from "app/webservice/jwt.service";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private _router: Router, private _jwt: JWTService) { }

  canActivate() {
    if (this._jwt.checkToken()) {
      return true;
    } else {
      this._router.navigate(['/login'])
      return false;
    }
  }
}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/webservice/authguard.service.ts